<template lang="pug">
    include AddLogo.pug
</template>

<script>
import _ from "underscore"
import Api from "@/components/services/Api";
import { mapState } from 'vuex';

export default {
  name: 'AddLogo',
  computed: _.extend(mapState([
    "context", "token",
  ]), {
    visible: function() {
      if (!this.plan) return false
      return (this.plan != 'basic')
    }
  }),
  data() {
    return {
      codeLogo: '',
      codeInsignia: '',
      plan: null,
    }
  },
  async created() {
    this.codeLogo =
      '<div class="fedfitnessbadge" data-application="esreps"></div><script type="text/javascript" src="https://api.creafitness.com/v1/esreps/badge.js"><\/script>'
    this.codeInsignia =
      '<div class="fedfitnessbadge" data-application="fef"></div><script type="text/javascript" src="https://api.creafitness.com/v1/esreps/badge.js"><\/script>'

    if (this.token) {
      const meResponse = await Api.me(this.token)
      const data = meResponse.data
      const plan = data.plan
      this.plan = plan
    }
  },
  methods: {},
}
</script>

<style scoped lang="scss">
@import './../variables';
@import 'AddLogo';
.context-colreps {
  @import 'AddLogoColreps';
}
</style>



// WEBPACK FOOTER //
// src/components/AddLogo.vue